import notificationChannel from "../../../../javascript/channels/notifications/notification_channel";

export default class extends Controller {
  static targets = ["count"];

  connect() {
    notificationChannel.init();
    App.Helpers.listenToCustomEvent(document, "archive-all-notifications:complete", this.close);
    App.Helpers.listenToCustomEvent(document, "notifications-updated", ((event) => this.updateCount(event.detail)).bind(this));
  }

  updateCount({ count, connected=true }) {
    this.count = count;
    this.isConnected = connected;
  }

  toggle(event) {
    event.preventDefault();
    App.ActivityNotification.togglePopover();
  }

  close(event) {
    event && event.preventDefault();
    App.ActivityNotification.closePopover();
  }

  //
  // GETTERS AND SETTERS
  //

  set count(val) {
    this.countTarget.innerHTML = val;
    this.countTarget.classList[val ? "remove" : "add"]("empty");
  }

  get count() {
    return this.countTarget.innerHTML.trim();
  }

  set isConnected(val) {
    this.countTarget.setAttribute("title", val ? `${this.count} unread notifications` : "Server connection lost - try refreshing the page");
  }
};



// WEBPACK FOOTER //
// ./app/components/notifications/assets/javascript/notifications-popover-button-controller.js